import {Pipe, PipeTransform} from '@angular/core';
import {CurrencyPipe} from "@angular/common";
import {TranslateService} from "@ngx-translate/core";

/**
 * Pipe that transforms a numeric value into a localized currency format based on the current language.
 *
 * It uses Angular `CurrencyPipe` internally to handle the currency formatting.
 *
 * @param {any} value - The numeric value to be formatted.
 * @param {string} [currencyCode='USD'] - The ISO 4217 currency code, defaults to 'USD' if not specified.
 * @param {'code' | 'symbol' | 'symbol-narrow' | string} [display='symbol'] - The display formatting style for the currency: 'code', 'symbol', 'symbol-narrow', or a custom string.
 * @param {string} [digitsInfo] - Optional string defining the number of decimal digits to format.
 * @returns {any} The formatted currency string, based on the current language.
 */
@Pipe({
    name: 'localizedCurrency',
    pure: false
})
export class LocalizedCurrencyPipe implements PipeTransform {

    constructor(private translateService: TranslateService) {
    }

    transform(value: any, currencyCode: string = 'USD', display: 'code' | 'symbol' | 'symbol-narrow' | string = 'symbol', digitsInfo?: string): any {
        const currentLang = this.translateService.currentLang || 'en';
        const currencyPipe = new CurrencyPipe(currentLang);

        if (digitsInfo) {
            return currencyPipe.transform(value, currencyCode.toUpperCase(), display, digitsInfo);
        } else {
            // Validate if the value is a number
            if (typeof value === 'number' && !isNaN(value)) {
                // Check if the number is a whole number
                if (value % 1 === 0) {
                    // Use '1.0-0' to show no decimals for whole numbers
                    return currencyPipe.transform(value, currencyCode.toUpperCase(), display, '1.0-0').replace('-', '\u2011'); //replacing of minus sign if any to avoid breaking
                } else {
                    // Use '1.2-2' to show two decimals for non-whole numbers
                    return currencyPipe.transform(value, currencyCode.toUpperCase(), display, '1.2-2').replace('-', '\u2011'); //replacing of minus sign if any to avoid breaking
                }
            } else {
                return null;
            }
        }

    }
}
